import React from 'react';
import { StyleSheet, Animated, Platform, View, TextInput } from 'react-native';
import i18n from 'i18n-js';

import { isPhone, isIOS } from '@helpers';
import { scale, notchTop } from '@components/frame';

import BackButton from '@components/common/backButton';

import ColorWrapper from '@styles/colors';
import Svg from '@styles/icons/svg';
import { font } from '@styles/fonts';

const Header = ({ length, text, C }) => {
  return (
    <Animated.View
      style={[
        {
          marginHorizontal: scale(18),
          borderBottomWidth: 0,
          marginTop: isPhone ? scale(22 + notchTop) : 50,
          marginBottom: scale(30),
          borderBottomColor: C('Hairline/Light/Header'),
          backgroundColor: C('Background / Light / System'),
        },
      ]}
    >
      <BackButton {...{ top: 0, padding: 0, left: -10 }} />
      <Animated.Text style={[font['Button 2'], { color: C('Label / Light / Tertiary'), marginTop: scale(13) }]}>
        {length ? `${length} ${i18n.t('ACTIVE')}` : ' '}
      </Animated.Text>
      <Animated.Text style={[font['Large Title'], { marginTop: scale(2) }, { color: C('Label / Light / Primary') }]}>{text}</Animated.Text>
    </Animated.View>
  );
};

export default ColorWrapper(Header);
